import React, { useContext } from 'react';
import styled from 'styled-components';
import { Grid, Typography } from '@material-ui/core';

import Box from '../ui/Boxes/Box';
import NoPatron from '../layout/Pane/NoPatron';
import CardFront from '../layout/Card/CardFront';
import CardBack from '../layout/Card/CardBack';
import SingleCard from '../layout/Card/SingleCard';
import FrontCommuCard from '../layout/Card/FrontCommuCard';
import BackCommuCard from '../layout/Card/BackCommuCard';
import { PatronContext } from '../../contexts/PatronContext';
import { PaneContext } from '../../contexts/PaneContext';
import { UserContext } from '../../contexts/UserContext';

const CardPreview = () => {
  const { patron } = useContext(PatronContext);
  const { newPatronMode } = useContext(PaneContext);
  const { Site } = useContext(UserContext);

  return patron.externalID || newPatronMode ? (
    <Container
      container
      spacing={4}
      style={{
        width: '100%',
        margin: 0,
      }}
    >
      {(Site.siteType === 0 && Site.orientation === 0) ||
      (Site.siteType === 2 && Site.orientation === 0) ||
      (Site.siteType === 4 && Site.orientation === 0) ||
      (Site.siteType === 5 && Site.orientation === 0) ? (
        <>
          <Grid item xs={12} sm={6} lg={12}>
            <Box label='Front'>
              <CardFront />
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} lg={12}>
            <Box label='Back'>
              <CardBack />
            </Box>
          </Grid>
        </>
      ) : Site.siteType === 6 ? (
        <>
          <Grid item xs={12} sm={6} lg={12}>
            <Box label='Front'>
              <FrontCommuCard />
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} lg={12}>
            <Box label='Back'>
              <BackCommuCard />
            </Box>
          </Grid>
        </>
      ) : (
        <Grid item xs={12} sm={6} lg={12}>
          <Box label='Example'>
            <SingleCard />
          </Box>
        </Grid>
      )}
      <Typography
        variant='caption'
        color='textSecondary'
        style={{ padding: '0 2rem', color: 'yellow', fontSize: '14px' }}
      >
        <b>Please note:</b> this preview is a generic card and doesn't reflect
        your School/Card design.
      </Typography>
    </Container>
  ) : (
    <NoPatron />
  );
};

const Container = styled(Grid)`
  padding: 2rem;
`;

export default CardPreview;
